import React from 'react'
import '../CSS/bootstrap.min.css'
import '../CSS/style.css'
import Fetch from '../Auxiliares/fetch'

const testConnection = () => {
    Fetch('/test', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(response => {
            console.log(response.mensaje)
        })
}

const Footer = (props) => (
    <footer className="footer-section bg-dark">
    <div className="footer-social">
        <a href="http://www.facebook.com">Facebook</a>
        <a href="http://www.twitter.com">Twitter</a>
        <a href="http://www.instagram.com">Instagram</a>
    </div>
    <div className="copyright">
        <p>
            Copyright <div className="d-inline-block" onClick={testConnection}>&copy;</div> |
            Todos los derechos reservados | Instituto Tecnologico de Mexicali
        </p>
    </div>
</footer>
)
export default Footer
